"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));

var SegmentMatches_1 = tslib_1.__importStar(require("./SegmentMatches"));

var SEGMENT_WIDTH = 180;
var BASE_SPACE = 5;
var BASE_MARGIN = (BASE_SPACE / 2 + SegmentMatches_1.SEGMENT_HEIGHT / 2) * 2;

var getMargin = function (idx) {
  var totalMargin = BASE_SPACE;
  var modifier = BASE_MARGIN;

  for (var i = 0; i <= idx; i++) {
    if (i > 0) {
      totalMargin = totalMargin + modifier;
      modifier = modifier * 2;
    }
  }

  return totalMargin / 2;
};

var Rounds = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-shrink: 0;\n  overflow-x: scroll;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-shrink: 0;\n  overflow-x: scroll;\n  width: 100%;\n"])));
var RoundName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding: ", " 0;\n  text-align: center;\n  margin-bottom: ", ";\n  color: ", ";\n  border: ", ";\n  font-size: ", ";\n  font-weight: bold;\n"], ["\n  padding: ", " 0;\n  text-align: center;\n  margin-bottom: ", ";\n  color: ", ";\n  border: ", ";\n  font-size: ", ";\n  font-weight: bold;\n"])), polished_1.rem(10), polished_1.rem(10), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
}, function (_a) {
  var theme = _a.theme;
  return polished_1.rem(1) + " solid " + theme.app.textColor;
}, polished_1.rem(13));
var RoundSegment = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  border: ", " solid ", ";\n  margin: ", ";\n  height: ", ";\n  position: relative;\n  &:first-child {\n    margin-top: 0;\n  }\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  border: ", " solid ", ";\n  margin: ", ";\n  height: ", ";\n  position: relative;\n  &:first-child {\n    margin-top: 0;\n  }\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, function (_a) {
  var roundIdx = _a.roundIdx;
  return getMargin(roundIdx) + "px 0";
}, polished_1.rem(SegmentMatches_1.SEGMENT_HEIGHT));
var RoundConnector = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  position: absolute;\n  left: ", ";\n  width: 1px;\n  top: ", ";\n  background: ", ";\n"], ["\n  height: ", ";\n  position: absolute;\n  left: ", ";\n  width: 1px;\n  top: ", ";\n  background: ", ";\n"])), function (_a) {
  var roundIdx = _a.roundIdx;
  return getMargin(roundIdx) * 2 + 2 * SegmentMatches_1.SEGMENT_HEIGHT - SegmentMatches_1.SEGMENT_HEIGHT + "px";
}, "calc(100% + " + polished_1.rem(SegmentMatches_1.SEGMENT_HEIGHT / 2 - 1) + ")", function (_a) {
  var idx = _a.idx,
      roundIdx = _a.roundIdx;
  return polished_1.rem(SegmentMatches_1.SEGMENT_HEIGHT / 2 + (getMargin(roundIdx) * 2 + 2 * SegmentMatches_1.SEGMENT_HEIGHT - SegmentMatches_1.SEGMENT_HEIGHT) * idx);
}, function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
});
var RoundWrapper = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  margin-right: ", ";\n  min-width: ", ";\n  &:not(:first-child) ", " {\n    &:before {\n      content: '';\n      width: ", ";\n      height: ", ";\n      position: absolute;\n      top: 50%;\n      right: 100%;\n      background: ", ";\n    }\n  }\n  &:not(:last-child) ", " {\n    &:after {\n      content: '';\n      width: ", ";\n      height: ", ";\n      position: absolute;\n      top: 50%;\n      left: 100%;\n      background: ", ";\n    }\n  }\n  &:last-child {\n    ", " {\n      display: none;\n    }\n  }\n"], ["\n  margin-right: ", ";\n  min-width: ", ";\n  &:not(:first-child) ", " {\n    &:before {\n      content: '';\n      width: ", ";\n      height: ", ";\n      position: absolute;\n      top: 50%;\n      right: 100%;\n      background: ", ";\n    }\n  }\n  &:not(:last-child) ", " {\n    &:after {\n      content: '';\n      width: ", ";\n      height: ", ";\n      position: absolute;\n      top: 50%;\n      left: 100%;\n      background: ", ";\n    }\n  }\n  &:last-child {\n    ", " {\n      display: none;\n    }\n  }\n"])), polished_1.rem(SegmentMatches_1.SEGMENT_HEIGHT), polished_1.rem(SEGMENT_WIDTH), RoundSegment, polished_1.rem(SegmentMatches_1.SEGMENT_HEIGHT / 2 + 1), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, RoundSegment, polished_1.rem(SegmentMatches_1.SEGMENT_HEIGHT / 2 + 1), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, RoundConnector);
var Round = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  margin-top: ", ";\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"], ["\n  margin-top: ", ";\n  display: flex;\n  flex-direction: column;\n  position: relative;\n"])), function (_a) {
  var roundIdx = _a.roundIdx;
  return getMargin(roundIdx) + BASE_SPACE + "px";
});

var WidgetCompetitionDraw = function (_a) {
  var data = _a.data,
      renderEmpty = _a.renderEmpty;

  var getBranches = function (rounds) {
    var o = [];
    var modifier = 0;
    var iterationIdx = 1;

    for (var i = rounds.length - 1; i >= 0; i--) {
      var segments = [];
      var segmentMargin = 0;
      var roundMargin = 0;

      for (var j = 0; j < iterationIdx; j++) {
        segmentMargin = segmentMargin + Math.pow(2, j);

        if (j > 0) {
          roundMargin = roundMargin + Math.pow(2, j - 1);
        }
      }

      for (var k = Math.pow(2, i) - 1; k >= 0; k--) {
        segments.push({
          drawId: k + modifier
        });
      }

      modifier = modifier + Math.pow(2, i);
      iterationIdx = iterationIdx + 1;
      var round = rounds[rounds.length - 1 - i];
      o.push({
        _id: round._id,
        name: round.name,
        segments: segments,
        segmentMargin: segmentMargin,
        roundMargin: roundMargin
      });
    }

    return o;
  };

  if ((!data.data || !data.partId) && renderEmpty) {
    return React.createElement(React.Fragment, null, renderEmpty('competitionDraw'));
  }

  if (data.data) {
    var _b = data.data,
        competitionPart = _b.competitionPart,
        matches_1 = _b.matches;
    var branches_1 = getBranches(competitionPart.rounds || []);
    var totalSegments_1 = 0;

    for (var a = 0; a < (competitionPart.rounds || []).length; a++) {
      totalSegments_1 = totalSegments_1 + Math.pow(2, a);
    }

    return branches_1.length > 0 ? React.createElement(Rounds, null, branches_1.map(function (branch, roundIdx) {
      var hasMatches = matches_1.find(function (m) {
        return m.round && m.round._id === branch._id && m.drawId;
      });

      if (!hasMatches) {
        return null;
      }

      return React.createElement(RoundWrapper, {
        key: "round_" + roundIdx
      }, React.createElement(RoundName, null, branch.name), React.createElement(Round, {
        roundIdx: roundIdx,
        margin: branch.roundMargin
      }, branch.segments.map(function (segment, idx) {
        var segmentDrawId = totalSegments_1 - segment.drawId;
        var segmentMatches = matches_1.filter(function (m) {
          return m.drawId && m.drawId === segmentDrawId;
        });
        var homeTeam = segmentMatches.length > 0 && ((segmentMatches[0].teams || []).find(function (t) {
          return t.additionalProperties && t.additionalProperties.homeaway && t.additionalProperties.homeaway === 'home';
        }) || (segmentMatches[0].teams || [])[0]);
        var awayTeam = segmentMatches.length > 0 && ((segmentMatches[0].teams || []).find(function (t) {
          return t.additionalProperties && t.additionalProperties.homeaway && t.additionalProperties.homeaway === 'away';
        }) || (segmentMatches[0].teams || [])[1]);
        return React.createElement(React.Fragment, {
          key: "segment_" + idx
        }, React.createElement(RoundSegment, {
          roundIdx: roundIdx,
          margin: branch.segmentMargin
        }, segmentMatches.length > 0 && React.createElement(SegmentMatches_1["default"], {
          segmentMatches: segmentMatches,
          homeTeam: homeTeam || undefined,
          awayTeam: awayTeam || undefined
        })), idx % 2 === 0 && roundIdx !== branches_1.length - 1 && React.createElement(RoundConnector, {
          margin: branch.segmentMargin,
          idx: idx,
          roundIdx: roundIdx
        }));
      })));
    })) : null;
  }

  return null;
};

exports["default"] = WidgetCompetitionDraw;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;